import React, { useEffect, useState } from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/dashboardFiltersSaga";
import { useSelector, useDispatch } from "react-redux";
import { isModuleActive } from "../../../../utils/modules";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const REVENUE_MODULES = ["revenueBreakdown", "membershipRevenue", "totalRevenue"];

const isActiveRevenueModules = (preferences) => {
  return REVENUE_MODULES.some((moduleName) => isModuleActive(preferences, moduleName));
};

const RevenueTypeFilter = () => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const selectedRevenueType = useSelector((state) => state.dashboardFilters.revenue_type);
  const isRevenueTypeLoading = useSelector((state) => state.dashboardFilters.isRevenueTypeLoading);
  const revenueTypeOptions = useSelector((state) => state.dashboardFilters.revenueTypeOptions);
  const preferences = useSelector((state) => state.commonReducer.preferences);

  useEffect(() => {
    const isShowFilter = isActiveRevenueModules(preferences);
    if (isShowFilter) {
      dispatch(actionCreators.fetchRevenueTypeFilter());
    }
    setShowFilter(isShowFilter);
  }, [preferences]);

  return showFilter ? (
    <div id="revenueTypeFilter">
      <div className="select-wrapper">
        <p className="offers-title">Revenue type</p>
        {isRevenueTypeLoading || !selectedRevenueType.id ? (
          <LoadingAnimation uiLoader />
        ) : (
          <MultiSelectDropdown
            options={revenueTypeOptions}
            selectedFilters={selectedRevenueType}
            placeholder="Select type"
            numberDisplayed={0}
            multiple={false}
            includeFilter={false}
            onSelectChange={(data) => {
              if (data.id === selectedRevenueType.id) return;
              dispatch(actionCreators.updateRevenueType(data));
            }}
          />
        )}
      </div>
    </div>
  ) : null;
};

export default RevenueTypeFilter;
